import React from 'react';
import styled from 'styled-components';
import ImportScript from './importScript';

const CommentWrapper = styled.div`
  .commento-root .commento-star-rating-input-top {
    color: #ffb400;
  }

  .commento-root .commento-submit-button {
    background-color: #85aa5e;
  }
`;

const CommnetSystem = () => {
  ImportScript('https://commento.hrdcen.com/js/commento.js');

  return (
    <CommentWrapper className="row comment-system justify-content-start my-1 my-lg-1 p-3">
      <div className="col col-12 col-lg-12">
        <h3 className="text-left mb-4 ps-0">
          수강후기 작성하기
        </h3>
        <div id="commento"></div>
      </div>
    </CommentWrapper>
  )
}

export default CommnetSystem;